import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import { appConfig } from "../../../config";
// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import {
  getAffiliateDashboard,
  getAffiliateDashboardByUser
} from "../../../redux/actions/affiliateActions";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "../../../slider/slider-animations.css";
import "../../../slider/styles.css";

import auth from "../../../services/auth";

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateData: {},
      affiliateResult: {},
      affiliateDeals: [],
      currentIndex: 0,
      translateValue: 0
    };
  }
  goToPrevSlide = () => {
    if (this.state.currentIndex === 0) return;

    this.setState(prevState => ({
      currentIndex: prevState.currentIndex - 1,
      translateValue: prevState.translateValue + this.slideWidth()
    }));
  };

  goToNextSlide = () => {
    if (this.state.currentIndex === this.state.images.length - 1) {
      return this.setState({
        currentIndex: 0,
        translateValue: 0
      });
    }

    // This will not run if we met the if condition above
    this.setState(prevState => ({
      currentIndex: prevState.currentIndex + 1,
      translateValue: prevState.translateValue + -this.slideWidth()
    }));
  };

  slideWidth = () => {
    return document.querySelector(".slide").clientWidth;
  };

  componentWillMount() {
    let affiliateIdParams = this.props.match.params.affiliateID
      ? this.props.match.params.affiliateID
      : "";
    if (affiliateIdParams !== "") {
      this.props.getAffiliateDashboard(affiliateIdParams);
    }
    const userinfo = auth.getUserInfo();
    if (userinfo.user_sec_id !== "") {
      this.props.getAffiliateDashboardByUser(userinfo.user_sec_id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.affiliateDashboard !== nextProps.affiliateDashboard) {
      if (nextProps.affiliateDashboard) {
        this.setState({
          affiliateData: nextProps.affiliateDashboard.data,
          affiliateResult: nextProps.affiliateDashboard.data.result,
          affiliateDeals: nextProps.affiliateDashboard.data.deals
        });
      }
    }

    if (this.props.affDashboardByuser !== nextProps.affDashboardByuser) {
      if (nextProps.affDashboardByuser) {
        this.setState({
          affiliateData: nextProps.affDashboardByuser.data,
          affiliateResult: nextProps.affDashboardByuser.data.result,
          affiliateDeals: nextProps.affDashboardByuser.data.deals
        });
      }
    }
  }

  render() {
    let affiliateData = this.state.affiliateData
      ? this.state.affiliateData
      : {};
    let affiliateResult = this.state.affiliateResult
      ? this.state.affiliateResult
      : [];
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div className="col-lg-12 add-sub-admin">
        <header className="panel-heading">Affiliate Dashboard </header>
        <div className="panel">

          <header className="panel-heading">Link Format </header>
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                  <FormGroup controlId="formOfferTitle">
                    <span>{affiliateData.LinkFormat}</span>
                  </FormGroup>

                  <FormGroup controlId="formOfferTitle">
                    <ControlLabel>market: </ControlLabel>

                    <span>
                      City to direct to (defaults to {affiliateResult.deal_city})
                    </span>
                  </FormGroup>
                  <FormGroup controlId="formTermsAndConditions">
                    <ControlLabel>aff_id: </ControlLabel>

                    <span>
                      Your affiliate ID ({affiliateResult.user_sec_id})
                    </span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="panel">
          <header className="panel-heading">RSS Feed</header>
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                  <FormGroup controlId="formExpirationMonth">
                    <ControlLabel>Local Offers:</ControlLabel>

                    <span>{affiliateData.LocalOffers}</span>
                  </FormGroup>
                  <FormGroup controlId="formExpirationDate">
                    <ControlLabel>National Offers:</ControlLabel>

                    <span>{affiliateData.NationalOffers}</span>
                  </FormGroup>
                  <FormGroup controlId="formMinQuantity">
                    <ControlLabel>Note:</ControlLabel>

                    <span>{affiliateResult.notes}</span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <div className="panel">
          <header className="panel-heading">Slideshow Widgets (300x250)</header>
          <div className="panel-body">
            <Row>
              <Col md={12} xs={12}>
              {(affiliateResult.permalink) &&
              <iframe src={`${window.location.origin}/affiliate/${affiliateResult.permalink}`} width="300px" frameBorder="0" height="260px" scrolling="no"></iframe>
              }
              </Col>
              <Col md={12} xs={12}>
              {(affiliateResult.permalink) &&
               <FormGroup controlId="banner300x250">
                  <FormControl componentClass="textarea" defaultValue={`<iframe src='${window.location.origin}/affiliate/${affiliateResult.permalink}' width="300px" frameBorder="0" scrolling="no" height="250px"></iframe>`} placeholder="textarea" />
                </FormGroup>
              }
              </Col>
            </Row>
          </div>
        </div>

        <div className="panel">
          <header className="panel-heading">Links & Banner Code</header>
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                  <FormGroup controlId="formMerchantID">
                    <ControlLabel>Standard Link</ControlLabel>
                    <br />
                    Takes user to our home page
                    <br />
                    <span>
                      <b>{affiliateData.StandardLink}</b>
                    </span>
                  </FormGroup>
                  <FormGroup controlId="formMerchantLegalName">
                    <ControlLabel>Slideshow Widgets</ControlLabel>
                    <br />
                    Banner advertises all active flash offers
                    <br />
                  </FormGroup>

                  {affiliateData.deals ? (
                    <iframe src={`${window.location.origin}/affiliate/${affiliateResult.permalink}`} width="100%" frameBorder="0" scrolling="no" height="400px"></iframe>
                  ) : (
                    ""
                  )}
                  {(affiliateResult.permalink) &&
                   <FormGroup controlId="banner300x250">
                      <FormControl componentClass="textarea" defaultValue={`<iframe src='${window.location.origin}/affiliate/${affiliateResult.permalink}' width="100%" frameBorder="0" scrolling="no" height="400px"></iframe>`} placeholder="textarea" />
                    </FormGroup>
                  }
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    affiliateDashboard: state.affiliateReducer.affiliateDashboard,
    affDashboardByuser: state.affiliateReducer.affDashboardByuser
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getAffiliateDashboard,
    getAffiliateDashboardByUser
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/affiliate/dashboard/Dashboard.js